import React from "react";
import { ClipboardCheckIcon, FileTextIcon, GitForkIcon, MapIcon, TableIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { tools, ToolIcon } from "../data/content";
const iconMap: Record<ToolIcon, BoxIcon> = {
  protocol: FileTextIcon,
  checklist: ClipboardCheckIcon,
  framework: GitForkIcon,
  matrix: TableIcon,
  roadmap: MapIcon
};
export function Tools() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-334" data-mp="205blljwlds75">
      <div className="mx-auto max-w-3xl" data-id="element-335" data-mp="2440vv3mc2tmk">
        <div id="tools-title" data-id="element-336" data-mp="1qdnmqxxph8vn">
          <SectionHeading eyebrow="Also included — immediate access" title={<>More Than <span className="italic text-gold" data-id="element-338" data-mp="1vbyw77k39hdc">30 Planning Tools</span>, Protocols & Worksheets</>} data-id="element-337" data-mp="1qcciyy49g14j" />
        </div>

        <ul className="mt-10 divide-y divide-navy/10 rounded-3xl bg-cream px-5 ring-1 ring-navy/10" data-id="element-339" data-mp="2j11pjco34yno">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-5" data-id="element-340" data-mp="2p15vtztfl54x">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy text-gold-light" data-id="element-341" data-mp="2ozl1aa749m72">
                  <Icon aria-hidden="true" className="h-6 w-6" data-id="element-342" data-mp="2yrh05nh11gcc" />
                </span>
                <div data-id="element-343" data-mp="2ytbo7anlhokn">
                  <h3 className="font-serif text-lg font-bold text-navy" data-id="element-344" data-mp="2u10j7tdzzcl8">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-345" data-mp="38pmzbxbg88di">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-8 text-center font-serif text-xl font-bold leading-snug text-navy" data-id="element-346" data-mp="33q20dmwa400s">
          Whatever case you’re organizing, you’ll have a clear place to begin.
        </p>

        <div className="mt-10" data-id="element-347" data-mp="3csb7s3w93d9y">
          <CtaButton label="I Want Access to the Complete System" data-id="element-348" data-mp="3cp5k8t39sjgc" />
        </div>
      </div>
    </section>;
}